<div class="relative">
  <button
    type="button"
    (click)="toggle()"
    class="w-full flex items-center gap-2 px-4 py-2.5 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl text-left focus:bg-white dark:focus:bg-gray-900 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all">
    @if (selected) {
      <span class="fi fi-{{ selected.code.toLowerCase() }} rounded-sm shrink-0"></span>
      <span class="flex-1 truncate text-gray-900 dark:text-white">{{ selected.name }}</span>
    } @else {
      <span class="flex-1 truncate text-gray-400">{{ placeholder }}</span>
    }
    @if (clearable && selected) {
      <span (click)="clear($event)" title="Quitar filtro"
        class="shrink-0 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 cursor-pointer">
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </span>
    }
    <svg class="w-4 h-4 shrink-0 text-gray-400 transition-transform" [class.rotate-180]="open"
      fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  @if (open) {
    <div
      class="absolute left-0 right-0 mt-1 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-lg overflow-hidden"
      style="z-index: var(--z-dropdown)">
      <div class="p-2 border-b border-gray-100 dark:border-gray-800">
        <input
          type="text"
          [(ngModel)]="query"
          (click)="$event.stopPropagation()"
          placeholder="Buscar país…"
          class="w-full px-3 py-2 text-sm bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg outline-none focus:ring-2 focus:ring-brand-500" />
      </div>
      @if (filtered.length) {
        <cdk-virtual-scroll-viewport [itemSize]="ITEM_SIZE" [style.height.px]="viewportHeight" class="py-1">
          <button
            *cdkVirtualFor="let c of filtered"
            type="button"
            (click)="pick(c)"
            class="w-full flex items-center gap-2 px-3 h-9 text-sm text-left hover:bg-gray-100 dark:hover:bg-gray-800"
            [class.bg-brand-50]="c.code === value"
            [class.dark:bg-gray-800]="c.code === value">
            <span class="fi fi-{{ c.code.toLowerCase() }} rounded-sm shrink-0"></span>
            <span class="flex-1 truncate text-gray-900 dark:text-white">{{ c.name }}</span>
            @if (c.dialCode) {
              <span class="text-xs text-gray-400 shrink-0">{{ c.dialCode }}</span>
            }
          </button>
        </cdk-virtual-scroll-viewport>
      } @else {
        <div class="px-3 py-2 text-sm text-gray-400">Sin resultados</div>
      }
    </div>
  }
</div>
